import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { getLanguageFromPath } from "./i18n/languages";


// URL path prefix wins over any stored preference: /es/... must render Spanish
// on first paint, before any client-side effect runs.
const pathLanguage = getLanguageFromPath(
  typeof window !== "undefined" ? window.location.pathname : ""
);

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .use(detector)
  .init({
    lng: pathLanguage || undefined,
    // No explicit lng: the browser detector resolves the saved/user language,
    // and fallbackLng covers unknown languages.
    fallbackLng: "en",
    // Region-specific locales (zh-CN, pt-BR) must not fall back to a parent
    // language file (zh, pt) that does not exist on the server - otherwise
    // changeLanguage fails and keeps the previous language.
    load: "currentOnly",
    debug: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Only user-selected values (cookie/localStorage) plus the querystring
      // are trusted; navigator/htmlTag region variants (e.g. en-US) have no
      // matching locale file. First visit falls back to English.
      order: ['querystring', 'cookie', 'localStorage'],
      caches: ['cookie', 'localStorage'],
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
  });

export default i18n;